import * as Localization from "expo-localization";
import { Settings } from "luxon";

export function getActiveSystemLocale(): "en" | "sv" {
  return getLocale().systemLocale;
}

export function matchSystemLocale(locale: string) {
  if (locale.match(/^sv/)) {
    return "sv";
  }
  return "en";
}

const supportedLanguages = ["sv", "en"];

export function getAcceptLanguage() {
  return Localization.getLocales()
    .map((l) => l.languageTag)
    .join(",");
}

export function getLocale() {
  const locales = Localization.getLocales();
  let selectedLocale: string = "en-SE";
  let systemLocale: "en" | "sv" = "en";
  for (const locale of locales) {
    const languageCode = locale.languageCode?.toLowerCase();
    if (languageCode && supportedLanguages.includes(languageCode)) {
      selectedLocale = locale.languageTag;
      systemLocale = languageCode as "en" | "sv";
      break;
    }
  }

  return {
    locale: selectedLocale,
    systemLocale,
  };
}

export function setLuxonDefaults() {
  const { locale } = getLocale();

  Settings.defaultLocale = locale;
  Settings.defaultWeekSettings = {
    firstDay: 1,
    minimalDays: 1,
    weekend: [6, 7],
  };
}
